import { useState } from "react";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import { vehicles, vehicleFilters } from "@/mocks/vehicles";

export default function VehiculosPage() {
  const [brandFilter, setBrandFilter] = useState("Todos");
  const [fuelFilter, setFuelFilter] = useState("Todos");
  const [selected, setSelected] = useState<number | null>(null);

  const filtered = vehicles.filter((v) => {
    const brandOk = brandFilter === "Todos" || v.brand === brandFilter;
    const fuelOk = fuelFilter === "Todos" || v.fuel === fuelFilter;
    return brandOk && fuelOk;
  });

  const selectedVehicle = vehicles.find((v) => v.id === selected);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero */}
      <section className="relative h-72 md:h-96 flex items-center justify-center overflow-hidden">
        <img
          src="https://public.readdy.ai/ai/img_res/edited_f17fda1a43f4d4e7a36980b0ddfd43d7_600b441d.jpg"
          alt="Compra-venta vehículos GERPAT"
          className="absolute inset-0 w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-black/60"></div>
        <div className="relative z-10 text-center px-4">
          <span className="text-[#FF6B35] text-xs font-bold uppercase tracking-widest">Compra-venta</span>
          <h1 className="text-4xl md:text-5xl font-extrabold text-white mt-2" style={{ fontFamily: "'Barlow Condensed', sans-serif" }}>
            VEHÍCULOS DISPONIBLES
          </h1>
          <p className="text-gray-300 mt-3 text-base max-w-xl mx-auto">
            Furgonetas, camiones y vehículos comerciales con garantía de calidad
          </p>
        </div>
      </section>

      {/* Filters */}
      <section className="bg-[#f8f7f5] py-8 border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 md:px-6 flex flex-wrap gap-4 items-center">
          <div className="flex items-center gap-2">
            <label className="text-sm font-semibold text-[#1a1a1a]">Marca:</label>
            <select
              value={brandFilter}
              onChange={(e) => setBrandFilter(e.target.value)}
              className="text-sm border border-gray-200 rounded-lg px-3 py-2 bg-white cursor-pointer focus:outline-none focus:border-[#FF6B35]"
            >
              {vehicleFilters.brands.map((b) => <option key={b}>{b}</option>)}
            </select>
          </div>
          <div className="flex items-center gap-2">
            <label className="text-sm font-semibold text-[#1a1a1a]">Combustible:</label>
            <select
              value={fuelFilter}
              onChange={(e) => setFuelFilter(e.target.value)}
              className="text-sm border border-gray-200 rounded-lg px-3 py-2 bg-white cursor-pointer focus:outline-none focus:border-[#FF6B35]"
            >
              {vehicleFilters.fuels.map((f) => <option key={f}>{f}</option>)}
            </select>
          </div>
          <span className="text-sm text-gray-400 ml-auto">{filtered.length} vehículo{filtered.length !== 1 ? "s" : ""} encontrado{filtered.length !== 1 ? "s" : ""}</span>
        </div>
      </section>

      {/* Grid */}
      <section className="py-16 bg-[#f8f7f5]">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          {filtered.length === 0 ? (
            <div className="text-center py-20 text-gray-400">
              <i className="ri-car-line text-5xl mb-4 block"></i>
              <p>No hay vehículos con los filtros seleccionados.</p>
            </div>
          ) : (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
              {filtered.map((v) => (
                <div key={v.id} className="bg-white rounded-xl overflow-hidden group hover:-translate-y-1 transition-transform duration-300 cursor-pointer" onClick={() => setSelected(v.id)}>
                  <div className="relative w-full h-52 overflow-hidden">
                    <img src={v.image} alt={`${v.brand} ${v.model}`} className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500" />
                    {v.badge && (
                      <span className="absolute top-3 left-3 bg-[#FF6B35] text-white text-xs font-bold px-3 py-1 rounded-full">{v.badge}</span>
                    )}
                  </div>
                  <div className="p-5">
                    <h3 className="font-bold text-[#1a1a1a] text-lg">{v.brand} {v.model}</h3>
                    <div className="flex flex-wrap gap-2 mt-2 mb-3">
                      <span className="text-gray-400 text-xs flex items-center gap-1"><i className="ri-calendar-line"></i>{v.year}</span>
                      <span className="text-gray-400 text-xs flex items-center gap-1"><i className="ri-speed-line"></i>{v.km.toLocaleString()} km</span>
                      <span className="text-gray-400 text-xs flex items-center gap-1"><i className="ri-gas-station-line"></i>{v.fuel}</span>
                      <span className="text-gray-400 text-xs flex items-center gap-1"><i className="ri-settings-line"></i>{v.transmission}</span>
                    </div>
                    <div className="flex items-center justify-between">
                      <span className="text-2xl font-extrabold text-[#FF6B35]">{v.price.toLocaleString("es-ES")} €</span>
                      <button className="bg-[#1a1a1a] hover:bg-[#FF6B35] text-white text-xs font-semibold px-4 py-2 rounded-full transition-colors whitespace-nowrap cursor-pointer">
                        Ver detalles
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>

      {/* Modal */}
      {selectedVehicle && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 px-4" onClick={() => setSelected(null)}>
          <div className="bg-white rounded-2xl max-w-2xl w-full overflow-hidden" onClick={(e) => e.stopPropagation()}>
            <div className="relative w-full h-64">
              <img src={selectedVehicle.image} alt={`${selectedVehicle.brand} ${selectedVehicle.model}`} className="w-full h-full object-cover object-top" />
              <button onClick={() => setSelected(null)} className="absolute top-3 right-3 w-9 h-9 flex items-center justify-center bg-black/50 hover:bg-black text-white rounded-full cursor-pointer">
                <i className="ri-close-line text-lg"></i>
              </button>
              {selectedVehicle.badge && (
                <span className="absolute top-3 left-3 bg-[#FF6B35] text-white text-xs font-bold px-3 py-1 rounded-full">{selectedVehicle.badge}</span>
              )}
            </div>
            <div className="p-6">
              <h2 className="text-2xl font-extrabold text-[#1a1a1a] mb-1">{selectedVehicle.brand} {selectedVehicle.model}</h2>
              <div className="flex flex-wrap gap-3 mb-4">
                <span className="bg-[#f8f7f5] text-gray-600 text-xs px-3 py-1.5 rounded-full flex items-center gap-1"><i className="ri-calendar-line text-[#FF6B35]"></i>{selectedVehicle.year}</span>
                <span className="bg-[#f8f7f5] text-gray-600 text-xs px-3 py-1.5 rounded-full flex items-center gap-1"><i className="ri-speed-line text-[#FF6B35]"></i>{selectedVehicle.km.toLocaleString()} km</span>
                <span className="bg-[#f8f7f5] text-gray-600 text-xs px-3 py-1.5 rounded-full flex items-center gap-1"><i className="ri-gas-station-line text-[#FF6B35]"></i>{selectedVehicle.fuel}</span>
                <span className="bg-[#f8f7f5] text-gray-600 text-xs px-3 py-1.5 rounded-full flex items-center gap-1"><i className="ri-settings-line text-[#FF6B35]"></i>{selectedVehicle.transmission}</span>
                <span className="bg-[#f8f7f5] text-gray-600 text-xs px-3 py-1.5 rounded-full flex items-center gap-1"><i className="ri-palette-line text-[#FF6B35]"></i>{selectedVehicle.color}</span>
              </div>
              <p className="text-gray-500 text-sm leading-relaxed mb-5">{selectedVehicle.description}</p>
              <div className="flex items-center justify-between">
                <span className="text-3xl font-extrabold text-[#FF6B35]">{selectedVehicle.price.toLocaleString("es-ES")} €</span>
                <a href="tel:+34638250936" className="flex items-center gap-2 bg-[#FF6B35] hover:bg-[#e55a25] text-white font-bold px-6 py-3 rounded-full transition-colors whitespace-nowrap cursor-pointer">
                  <i className="ri-phone-fill"></i> Consultar
                </a>
              </div>
            </div>
          </div>
        </div>
      )}

      <Footer />
    </div>
  );
}
